// Imports for external libraries go here.
import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { TextComponent, size } from '@marriott/mi-ui-library';

import { OffersTextBlockProps } from './OffersTextBlock.types';
import { StyledOffersTextBlock } from './OffersTextBlock.styles';

export const OffersTextBlockonfig = {
  emptyLabel: 'OfferTextBlock',
  isEmpty: false,
  resourceType: `mi-aem-offers-spa/components/offerstextblock`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OffersTextBlock: React.FC<OffersTextBlockProps> = (props: any) => {
  const { model, offersData } = props;
  const contentBlockText = offersData?.responseObject?.offers?.[0]?.merchandisingOffer?.singleCard?.contentBlock;
  const descriptionText = offersData?.responseObject?.offers?.[0]?.termsAndConditions;
  return (
    <EditableComponent config={OffersTextBlockonfig} {...props}>
      <StyledOffersTextBlock data-testid="offers-textblock" data-component-name="o-offers-textblock">
        <div className="offer-text-block">
          {model?.variation === 'tc-footnote' ? (
            <TextComponent
              {...model}
              componentId={model?.componentId}
              descriptionText={descriptionText}
              descriptionFontSize={size.extraSmall}
            />
          ) : (
            <TextComponent //Added the description when in model we get variation as description
              componentId={model?.componentId}
              descriptionText={contentBlockText}
              descriptionFontSize={size.extraSmall}
              styleclass="custom-text-contentBlock"
            />
          )}
        </div>
      </StyledOffersTextBlock>
    </EditableComponent>
  );
};
